import React, { useState } from "react";
import AppLayout from "../components/AppLayout";
import { api } from "../lib/api";
import { Copy, Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function DMReplies() {
  const [dm, setDm] = useState("");
  const [ctx, setCtx] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    if (!dm.trim()) return;
    setBusy(true); setRes(null);
    try {
      const r = await api.post("/api/dm/generate-replies", { dm_text: dm, context: ctx });
      setRes(r.data);
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  const copy = (t) => { navigator.clipboard.writeText(t); toast.success("Copied, κούκλε"); };

  const toneColor = { casual: "text-zinc-300", flirty: "text-[color:var(--gio-primary)]", sales: "text-[color:var(--gio-secondary)]" };

  return (
    <AppLayout title="DM Replies" overline="020 · THREE OPTIONS · CASUAL / FLIRTY / SALES">
      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-6">
        <section className="border border-zinc-900 bg-zinc-950 p-6 fade-up" data-testid="dm-input-panel">
          <div className="overline mb-3">Fan's DM</div>
          <textarea value={dm} onChange={(e) => setDm(e.target.value)} rows={8}
            placeholder="Paste the DM here..."
            data-testid="dm-input"
            className="w-full bg-black border border-zinc-900 text-white p-3 text-sm focus:outline-none focus:border-[color:var(--gio-primary)]" />

          <div className="overline mt-6 mb-3">Extra context (optional)</div>
          <textarea value={ctx} onChange={(e) => setCtx(e.target.value)} rows={3}
            placeholder="e.g. already subscribed, loves feet, from Athens..."
            data-testid="dm-context-input"
            className="w-full bg-black border border-zinc-900 text-white p-3 text-sm focus:outline-none focus:border-[color:var(--gio-primary)]" />

          <button onClick={generate} disabled={busy || !dm.trim()} data-testid="dm-generate-button"
            className="btn-primary mt-6 w-full flex items-center justify-center gap-2 disabled:opacity-40">
            <Sparkles size={16} /> {busy ? "Cooking..." : "Generate 3 replies"}
          </button>
        </section>

        <section className="space-y-4" data-testid="dm-results">
          {!res && !busy && (
            <div className="border border-dashed border-zinc-900 p-12 text-center text-zinc-600 text-sm fade-up">
              Your 3 replies will land here.
            </div>
          )}
          {busy && <div className="overline text-[color:var(--gio-primary)] p-6">GIOAGENT IS THINKING...</div>}
          {res?.replies?.map((r, i) => (
            <div key={i} className="border border-zinc-900 bg-zinc-950 p-5 fade-up" data-testid={`dm-reply-${r.tone}`}>
              <div className="flex items-center justify-between mb-3">
                <div className={`overline ${toneColor[r.tone] || ""}`}>{r.tone}</div>
                <button onClick={() => copy(r.text)} data-testid={`dm-copy-${r.tone}`}
                  className="text-zinc-500 hover:text-[color:var(--gio-primary)] transition flex items-center gap-1 text-xs font-mono-ui">
                  <Copy size={14} /> COPY
                </button>
              </div>
              <div className="text-white text-sm leading-relaxed whitespace-pre-wrap">{r.text}</div>
            </div>
          ))}
          {res && !res.replies?.length && res.raw && (
            <pre className="border border-zinc-900 bg-zinc-950 p-4 text-xs text-zinc-400 whitespace-pre-wrap">{res.raw}</pre>
          )}
        </section>
      </div>
    </AppLayout>
  );
}
